import { Outlet, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MorphingBackground } from '../animations/MorphingBackground';
import { ParticleBackground } from '../animations/ParticleBackground';
import { useUIStore } from '../../stores/uiStore';

export function AdminLayout() {
  const location = useLocation();
  const { sidebarCollapsed } = useUIStore();

  return (
    <div className="min-h-screen bg-bg relative overflow-hidden">
      {/* Particle background */}
      <ParticleBackground />

      {/* Animated gradient background */}
      <MorphingBackground />

      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <motion.div
        className="min-h-screen flex flex-col"
        initial={false}
        animate={{
          marginLeft: sidebarCollapsed ? 80 : 256,
        }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        style={{ marginLeft: 256 }}
      >
        <Header />

        <main className="flex-1 p-6 relative z-10 flex flex-col min-h-0">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 20, filter: 'blur(4px)' }}
              animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
              exit={{ opacity: 0, y: -20, filter: 'blur(4px)' }}
              transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
              className="flex-1 flex flex-col min-h-0"
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </motion.div>
    </div>
  );
}
